// removed by extract-text-webpack-plugin
module.exports = {"buttonContainer":"_23aWl1B1YPfxkl7A-aDk9y","dialogBoxFormat":"_1KoMcMNH61UFHneErVgdmI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DebtPhaseContracts/styles.css
// module id = 1064
// module chunks = 0